import { LoanApplicationService } from "../../services/LoanApplication";
import { CustomLoaderFunctionArgs } from "../../shared/router/RouteLoader";

export default async function quantificLoader({
  params,
  getToken,
  pageName
}: CustomLoaderFunctionArgs) {
  const { loanID, sourceEntityID } = params;

  return await LoanApplicationService.getFieldInvestigationDetails({
    loanApplicationID: loanID as string,
    token: getToken(),
    pageName,
    sourceEntityID: sourceEntityID as string
  });
}

export async function videoPDLoader({
  params,
  getToken,
  pageName
}: CustomLoaderFunctionArgs) {
  const { loanID, sourceEntityID } = params;
  return await LoanApplicationService.fetchInvestigationDetails({
    loanApplicationID: loanID as string,
    token: getToken(),
    pageName,
    sourceEntityID: sourceEntityID as string
  });
}
